// extracted by mini-css-extract-plugin
export default {"layoutToggleFormControl":"layout-toggle-module__layoutToggleFormControl--Emyt8"};